module.exports = __webpack_public_path__ + "img/file-minus-03.b4b3c93e.svg";